// The trust lattice's mark: assessed > verified > inferred (ADR-028). self_attested renders
// nothing — call sites split those signals into their own dormant section.
import type { VerificationStatus } from '@/types/engineer'
import { cn } from '@/lib/utils'

interface VerificationMarkMeta {
  glyph: string
  label: string
  className: string
}

const VERIFICATION_MARK_META: Record<Exclude<VerificationStatus, 'self_attested'>, VerificationMarkMeta> = {
  assessed: {
    glyph: '◆',
    label: 'assessed',
    className: 'rounded-full bg-primary px-[8px] py-[3px] text-primary-foreground',
  },
  verified: { glyph: '✓', label: 'verified', className: 'text-primary' },
  inferred: { glyph: '~', label: 'inferred', className: 'text-muted-foreground' },
}

interface VerificationMarkProps {
  status: VerificationStatus
  className?: string
}

export function VerificationMark({ status, className }: VerificationMarkProps) {
  if (status === 'self_attested') {return null}

  const meta = VERIFICATION_MARK_META[status]
  return (
    <span className={cn('inline-flex items-center gap-1 font-mono text-[11px]', meta.className, className)}>
      <span aria-hidden>{meta.glyph}</span>
      {meta.label}
    </span>
  )
}
